module.exports = __webpack_public_path__ + "img/title-en.551952df.png";